export function readAutosaveStorage(key) {
    if (!key)
        return {};

    try {
        const allAutosaveData = JSON.parse(localStorage.getItem('autosave_transactions') || {}) || {};
        const txnData = allAutosaveData[key];
        return txnData || {};
    }
    catch (e) {
        return {};
    }
}
